// src/components/auth/components/OLSCalendar.tsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";

const CalendarContainer = styled.div`
  width: 6rem;
  height: 2.5rem;
  background-color:rgb(134, 161, 14);
  border: 2px solid #00ff00;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
  padding: 5px 10px;

  @media (max-width: 768px) {
    width: 5rem;
    height: 2rem;
    padding: 3px 8px;
  }
`;

const DayNumber = styled.div`
  color: #ffffff;
  font-size: 1rem;
  font-weight: bold;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const OLSCalendar: React.FC = () => {
  const [currentDay, setCurrentDay] = useState(0);

  useEffect(() => {
    const calculateDays = () => {
      const startDate = new Date("2024-12-22");
      const today = new Date();
      const timeDiff = today.getTime() - startDate.getTime();
      const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
      setCurrentDay(daysDiff);
    };

    calculateDays();
    const interval = setInterval(calculateDays, 24 * 60 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <CalendarContainer>
      <DayNumber>Day {currentDay}</DayNumber>
    </CalendarContainer>
  );
};

export default OLSCalendar;